import RolesChecker from 'features/customer/components/RolesChecker';
import RequirementTypeEnumDTO from 'features/requirements/dtos/RequirementTypeEnumDTO';
import ModalHeader from 'features/shared/components/modal/ModalHeader';
import { groupBy } from 'features/shared/helpers/Arrays';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import RequirementTypeGroup from './RequirementTypeGroup';

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  requirementTypes: RequirementTypeEnumDTO[];
}

const RequirementTypesDialog = ({ show, setShow, requirementTypes }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // handlers
  const closeDialogHandler = () => {
    setShow(false);
  };

  // sub-renders
  const renderRequirementGroups = (): JSX.Element[] => {
    let result:JSX.Element[] = [];

    const filteredTypes = requirementTypes.filter(x => x.canCreate === true);
    const groups = groupBy<RequirementTypeEnumDTO>(filteredTypes, "category");
    const iterableGroups = Object.entries(groups);
    
    for (let i = 0; i < iterableGroups.length; i++) {
      const [category, group] = iterableGroups[i];
      const groupElem = (
        <RequirementTypeGroup
          name={category}
          types={group}
          closeDialogHandler={closeDialogHandler}
          key={i}
        />
      );

      result.push(groupElem);
    }

    return result;
  }
  
  // render
  return (
    <RolesChecker enabledRoles="Contributor">
      <Modal show={show} onHide={closeDialogHandler}>
        <ModalHeader title={tLabels("requirementTypesDialog.cardTitle")} onCloseClick={closeDialogHandler} />
        <div className="modal-body">
          {renderRequirementGroups()}
        </div>
      </Modal>
    </RolesChecker>
  );
}

export default RequirementTypesDialog;
